export default __webpack_public_path__ + "static/media/Roboto-Regular.27f62b53.ttf";